/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, July 11th 2022, 6:56:59 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { DeleteAPIResponse } from "lib/schemas";
import { useAPIMutation } from "lib/api";
import { PrimaryKeyValue, APIServicePathType } from "lib/types";

export const useDeleteOSItem = <T>(apiServicePath: APIServicePathType) => {
  const [versionId, setVersionId] = React.useState<DeleteAPIResponse["version_id"]>();

  const { deleteData, ...otherProperties } = useAPIMutation<DeleteAPIResponse>({ apiServicePath });

  const deleteItem = (
    itemId: PrimaryKeyValue<T>,
    options?: { onDelete: (itemId: PrimaryKeyValue<T>) => void; apiQueryParams?: any }
  ) => {
    deleteData({
      apiPathParams: [itemId],
      apiQueryParams: options?.apiQueryParams,
      setValidAPIResponse: (apiResponse) => {
        options?.onDelete?.(itemId);
        apiResponse?.version_id && setVersionId(apiResponse.version_id);
      },
    });
  };

  return { deleteItem, versionId, ...otherProperties };
};
